import NotificationsController   from "@/js/Webmail/Notifications/NotificationsController";
import Controller                from "@/js/Shared/Controllers/Controller";
import SmokescreenCollectionList from "./Collections/SmokescreenCollectionList";
import SmokescreenHTTPMapping    from "./HTTP/SmokescreenHTTPMapping";
import SmokescreenHTTPService from "./HTTP/SmokescreenHTTPService";

export { SmokescreenController as default };
/**
* Smokescreen Controller
*
* This controles enable smokescreen features, to generate disposable emails
*
* @author      Rúben Simões <ruben.r.simoes@meo.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.1.0
*/
class SmokescreenController extends Controller {
    /**
     * SmokescreenData Data
     *
     * @public
     *
     * @type {SmokescreenCollectionList}
     *
     * @since 7.0.0
     */
    data = new SmokescreenCollectionList('address');

    /**
     * HTTP Mapping object
     *
     * @private
     *
     * @type {SmokescreenHTTPMapping}
     *
     * @since 7.0.0
     */
    http_mapping = new SmokescreenHTTPMapping();

    /**
     * HTTP Service object
     *
     * @private
     *
     * @type {SmokescreenHTTPService}
     *
     * @since 7.0.0
     */
    http_service = new SmokescreenHTTPService();

    /**
     * Fetchs the entire smokescreen list
     *
     * @public
     *
     * @since 7.0.0
     *
     * @return {Promise.<boolean>}
     */
    async fetchSmokescreenList(reload = false) {
        if (this.content_state.loaded === true && reload === false) {
            return true;
        }

        this.content_state.setLoading();
        let response = await this.http_service.fetchSmokescreenList();

        if (response.success === false) {
            NotificationsController.addMessage('notifications.', response.messages);
            this.content_state.setLoadedState(response.success);
            return false;
        }

        this.http_mapping.mapList(this.data, response);
        this.content_state.setLoadedState(response.success);

        return response.success;
    }

    /**
     * Disables a smokescreen address
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {String} address email to remove whitelist
     *
     * @return {Promise.<boolean>}
     */
    async disableSmokescreenAddress(item) {
        this.saving_state.setSaving(item.address);
        let response = await this.http_service.disableSmokescreenAddresses([item.address]);
        NotificationsController.addMessage('notifications.', response.messages);

        if(response.success){
           this.http_mapping.mapDisableItem(item);
        }

        this.saving_state.unsetSaving(item.address);
        return response.success;
    }

    /**
     * Enables a smokescreen address
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {String} address email to remove whitelist
     *
     * @return {Promise.<boolean>}
     */
    async enableSmokescreenAddress(item) {
        this.saving_state.setSaving(item.address);
        let response = await this.http_service.enableSmokescreenAddresses([item.address]);
        NotificationsController.addMessage('notifications.', response.messages);

        if(response.success){
            this.http_mapping.mapEnableItem(item);
        }

        this.saving_state.unsetSaving(item.address);
        return response.success;
    }

    /**
     * Addresses a smokescreen address
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {String} address email to remove whitelist
     *
     * @return {Promise.<boolean>}
     */
    async addSmokescreenAddress(prefix) {
        this.saving_state.setSaving(prefix);
        let response = await this.http_service.addSmokescreenAddress(prefix);
        NotificationsController.addMessage('notifications.', response.messages);

        if(response.success) {
            this.http_mapping.mapAddItem(this.data, response);
        }

        this.saving_state.unsetSaving(prefix);
        return response.success;
    }
}